module.exports = __webpack_public_path__ + "img/9791190492911.42026c1e.jpg";